import HomeRoute from './home.jsx'

export default HomeRoute;